export var ClientConfiguration;
(function (ClientConfiguration) {
    ClientConfiguration.ByStage = {
        local: {
            isProduction: false,
            apiGateway: {
                REGION: "us-west-2",
                URL: "http://localhost:3001",
            },
        },
        localAndroidEmulator: {
            isProduction: false,
            apiGateway: {
                REGION: "us-west-2",
                URL: "http://10.0.2.2:3001",
            },
        },
        dev: {
            isProduction: false,
            apiGateway: {
                REGION: "us-west-2",
                URL: "https://dev.api.warmandfuzzy.house",
            },
        },
        prod: {
            isProduction: true,
            apiGateway: {
                REGION: "us-west-2",
                URL: "https://prod.api.warmandfuzzy.house",
            },
        },
    };
})(ClientConfiguration || (ClientConfiguration = {}));
//# sourceMappingURL=ClientConfiguration.js.map